import React from 'react'
import './formInputs.css'

export const Input = ({ name, error = false, onChange }) => {
  return (
    <input
      id={name}
      className={`Input ${error ? 'Input--error' : ''} u-marginTop1gu`}
      type="text"
      name={name}
      onChange={(e) => onChange(e)}
    />
  )
}

export const TextArea = ({
  name,
  error = false,
  onChange,
  placeholder = '',
  rows = 12,
}) => {
  return (
    <textarea
      id={name}
      className={`Input inline-table ${
        error ? 'Input--error' : ''
      } u-marginTop1gu u-textBreak`}
      name={name}
      placeholder={placeholder}
      rows={rows}
      onChange={(e) => onChange(e)}
    />
  )
}

export const Dropdown = ({ name, error = false, onChange, options = [] }) => {
  return (
    <div className="Dropdown-group">
      <div className={`Dropdown ${error ? 'Dropdown--error' : ''}`}>
        <select
          id={name}
          className="Dropdown-menu u-marginTop1gu"
          name={name}
          onChange={(e) => onChange(e)}
          defaultValue=""
        >
          {options.map((option) => (
            <option
              key={option.value}
              value={option.value}
              disabled={option.disabled}
            >
              {option.label}
            </option>
          ))}
        </select>
      </div>
    </div>
  )
}

export const InputGroup = ({
  name = '',
  label = null,
  error = false,
  hideErrorIcon = false,
  errorMessage,
  onChange,
  render,
  options = [],
  required = false,
}) => {
  if (!render) return null
  const inputName = `${name.toLowerCase().split(' ').join('')}_${Math.floor(
    Math.random() * 100
  )}`
  const message = errorMessage || `Please enter ${name.toLowerCase()}`
  return (
    <>
      <label htmlFor={inputName} className="Form-label">
        {label || name}
      </label>
      <div className="Input-group">
        {render({ name: inputName, error, onChange, options, required })}
        {error && !hideErrorIcon && (
          <span className="Input-icon Icon">&#xE002;</span>
        )}
      </div>
      {error && <p className="Form-help u-textColorAlert">{message}</p>}
    </>
  )
}
